import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Bàn Pricing (DeskBoard.tsx). Nhãn nhóm tuyến, thao tác, tình trạng lấy từ desk.ts qua khoá; dữ liệu mẫu (việc, thông báo, mã tuyến / hãng) không dịch.
addMessages('vi', {
  'dk.high': 'Cao',
  'dk.mid': 'Vừa',
  'dk.low': 'Thấp',
  'dk.noWrite': 'Chưa bật ghi Freight Cost',
  'dk.skipped': 'Đã bỏ qua · {v}',
  'dk.statusAria': 'Tình trạng tuyến giá',
  'dk.hilite': 'Làm nổi các ô {v}',
  'dk.c_ok': 'Còn hạn',
  'dk.c_soon': 'Sắp hết ≤ 7 ngày',
  'dk.c_exp': 'Hết hạn',
  'dk.c_none': 'Chưa có giá',
  'dk.rateLanes': 'tuyến giá',
  'dk.hiliteInq': 'Làm nổi ô có hỏi giá chờ',
  'dk.inqWait': 'Hỏi giá chờ',
  'dk.nearDue': '{n} sắp quá hạn',
  'dk.gridAria': 'Lưới hãng và tuyến',
  'dk.gridTitle': 'Hãng × Tuyến',
  'dk.followed': 'Tuyến đang theo dõi · {n}',
  'dk.lanesCars': '{a} tuyến · {b} hãng',
  'dk.lanesN': '{n} tuyến',
  'dk.carsN': '{n} hãng',
  'dk.followTip': 'Mở Services Map › Tuyến để bật / tắt Follow',
  'dk.pickFollow': 'Chọn tuyến theo dõi',
  'dk.group': 'Nhóm tuyến',
  'dk.r_all': 'Mọi tuyến',
  'dk.r_US': 'Mỹ',
  'dk.r_EU': 'Âu',
  'dk.r_AS': 'Á',
  'dk.r_OT': 'Khác',
  'dk.cargoType': 'Loại hàng',
  'dk.rfOnly': 'Chỉ RF',
  'dk.mainTip': 'Hãng chủ lực = top 8 hãng theo số job 12 tháng gần nhất · tự cập nhật mỗi đêm',
  'dk.main': 'Hãng chủ lực',
  'dk.tableAria': 'Tình trạng giá theo hãng và tuyến',
  'dk.lane': 'Tuyến',
  'dk.laneDetail': 'Chi tiết tuyến {v}',
  'dk.hasRate': '{a}/{b} hãng có giá',
  'dk.inqN': '{n} hỏi giá',
  'dk.noServe': 'hãng không chạy tuyến',
  'dk.days': '{n} ngày',
  'dk.left': 'còn {n} ngày',
  'dk.vsPrevPct': '{v} so kỳ trước',
  'dk.up': 'tăng so kỳ trước',
  'dk.down': 'giảm so kỳ trước',
  'dk.inqWaitN': '{n} hỏi giá chờ',
  'dk.none': 'Chưa có',
  'dk.vsPrev': 'so kỳ trước',
  'dk.inqWaitLow': 'hỏi giá chờ',
  'dk.right': 'Cột phải',
  'dk.queue': 'Hàng việc Pricing',
  'dk.noti': 'Thông báo',
  'dk.closePanel': 'Đóng bảng',
  'dk.readAll': 'Đánh dấu đã đọc tất cả',
  'dk.tasksHigh': '{a} việc · {b} cao',
  'dk.aiHead': 'Ask HANA · sáng nay',
  'dk.aiBody': '2 giá hết hạn trong 2 ngày vẫn còn báo giá / job · {n} hỏi giá chờ, gấp nhất CLI → NYC còn 5 giờ · CMA áp GRI châu Âu 01/Nov. Nên gia hạn MSC CLI → RTM trước.',
  'dk.qFilter': 'Lọc hàng việc',
  'dk.all': 'Tất cả',
  'dk.inq': 'Hỏi giá',
  'dk.qNone': 'Hết việc cần xử lý trong nhóm này.',
  'dk.openInq': 'Mở Hỏi giá đối tác · {n} chờ',
  'dk.a_ext': 'Gia hạn',
  'dk.a_ask': 'Hỏi hãng',
  'dk.a_enter': 'Nhập giá',
  'dk.a_skip': 'Bỏ qua',
  'dk.a_route': 'Xem tuyến',
  'dk.a_notify': 'Báo Sale',
  'dk.daysShort': '{n}n',
  'dk.c_soonS': 'Sắp hết',
  'dk.a_routeP': 'Tra tuyến',
  'dk.expDays': 'hết {n} ngày',
});
addMessages('en', {
  'dk.high': 'High',
  'dk.mid': 'Medium',
  'dk.low': 'Low',
  'dk.noWrite': 'Freight Cost writing is not enabled',
  'dk.skipped': 'Dismissed · {v}',
  'dk.statusAria': 'Lane rate status',
  'dk.hilite': 'Highlight {v} cells',
  'dk.c_ok': 'Valid',
  'dk.c_soon': 'Expiring ≤ 7 days',
  'dk.c_exp': 'Expired',
  'dk.c_none': 'No rate',
  'dk.rateLanes': 'rate lanes',
  'dk.hiliteInq': 'Highlight cells with pending inquiries',
  'dk.inqWait': 'Pending inquiries',
  'dk.nearDue': '{n} nearly overdue',
  'dk.gridAria': 'Carrier × lane grid',
  'dk.gridTitle': 'Carrier × Lane',
  'dk.followed': 'Followed lanes · {n}',
  'dk.lanesCars': '{a} lanes · {b} carriers',
  'dk.lanesN': '{n} lanes',
  'dk.carsN': '{n} carriers',
  'dk.followTip': 'Open Services Map › Lanes to toggle Follow',
  'dk.pickFollow': 'Choose lanes to follow',
  'dk.group': 'Lane group',
  'dk.r_all': 'All lanes',
  'dk.r_US': 'US',
  'dk.r_EU': 'Europe',
  'dk.r_AS': 'Asia',
  'dk.r_OT': 'Other',
  'dk.cargoType': 'Cargo type',
  'dk.rfOnly': 'RF only',
  'dk.mainTip': 'Key carriers = top 8 carriers by jobs in the last 12 months · refreshed nightly',
  'dk.main': 'Key carriers',
  'dk.tableAria': 'Rate status by carrier and lane',
  'dk.lane': 'Lane',
  'dk.laneDetail': 'Lane details {v}',
  'dk.hasRate': '{a}/{b} carriers with rates',
  'dk.inqN': '{n} inquiries',
  'dk.noServe': 'carrier does not serve this lane',
  'dk.days': '{n} days',
  'dk.left': '{n} days left',
  'dk.vsPrevPct': '{v} vs previous period',
  'dk.up': 'up vs previous period',
  'dk.down': 'down vs previous period',
  'dk.inqWaitN': '{n} inquiries pending',
  'dk.none': 'None',
  'dk.vsPrev': 'vs previous period',
  'dk.inqWaitLow': 'pending inquiries',
  'dk.right': 'Right panel',
  'dk.queue': 'Pricing queue',
  'dk.noti': 'Notifications',
  'dk.closePanel': 'Close panel',
  'dk.readAll': 'Mark all as read',
  'dk.tasksHigh': '{a} tasks · {b} high',
  'dk.aiHead': 'Ask HANA · this morning',
  'dk.aiBody': '2 rates expire within 2 days but still have quotes / jobs · {n} inquiries pending, most urgent CLI → NYC with 5 hours left · CMA applies a Europe GRI on 01/Nov. Extend MSC CLI → RTM first.',
  'dk.qFilter': 'Filter queue',
  'dk.all': 'All',
  'dk.inq': 'Inquiries',
  'dk.qNone': 'Nothing left to handle in this group.',
  'dk.openInq': 'Open partner inquiries · {n} pending',
  'dk.a_ext': 'Extend',
  'dk.a_ask': 'Ask carrier',
  'dk.a_enter': 'Enter rate',
  'dk.a_skip': 'Dismiss',
  'dk.a_route': 'View lane',
  'dk.a_notify': 'Notify Sales',
  'dk.daysShort': '{n}d',
  'dk.expDays': 'expired {n} days',
  'dk.c_soonS': 'Expiring',
  'dk.a_routeP': 'Check lane',
});
